import { render, staticRenderFns } from "./ReportSearch.vue?vue&type=template&id=160b1ddd"
import script from "./ReportSearch.vue?vue&type=script&lang=ts"
export * from "./ReportSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports